<template>
  <v-card>
    <v-card-title>
      {{ $t('reports.notes.label') }}
      <v-spacer />
      <v-btn icon small @click="notesEdit = !notesEdit" v-if="!pdfMode"><v-icon>mdi-pencil</v-icon></v-btn>
    </v-card-title>
    <v-card-text v-if="notesEdit">
      <v-textarea
        v-model="localComment"
        dense
        outlined
        rows="3"
        counter="1500"
      />
      <v-row class="ma-1">
        <v-spacer />
        <v-btn small color="primary" rounded @click="handleSave">
          {{ $t('common.save') }}
        </v-btn>
      </v-row>
    </v-card-text>
    <v-card-text v-else>
      <div v-html="parsedComment" />
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'ReportNotes',
  props: {
    comment: {
      type: String,
      default: ''
    },
    pdfMode: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      notesEdit: false,
      localComment: this.comment
    }
  },
  computed: {
    parsedComment () {
      return this.comment ? this.comment.replaceAll('\n', '<br />') : ''
    }
  },
  methods: {
    handleSave () {
      this.$emit('save', { comment: this.localComment })
      this.notesEdit = false
    }
  },
  watch: {
    comment (v) {
      this.localComment = v
    }
  }
}
</script>
